
// import React, { useRef, useState, useEffect } from "react";
// import { motion, useScroll, useTransform } from "framer-motion";
// import ServiceCard from "./ServiceCard";

// // import all your images (keeping your imports as is)...

// // // Images
// import DetoxImg from "../../assets/Services/Desktop/Rectangle10.png";
// import DetoxImgMob from "../../assets/Services/Mobile/Rectangle11.png";

// import IndividualTherapyImg from "../../assets/Services/Desktop/Rectangle101.png";
// import IndividualTherapyImgMob from "../../assets/Services/Mobile/Rectangle12.png";

// import GroupTherapyImg from "../../assets/Services/Desktop/Rectangle102.png";
// import GroupTherapyImgMob from "../../assets/Services/Mobile/Rectangle13.png";

// import FamilyTherapyImg from "../../assets/Services/Desktop/Rectangle103.png";
// import FamilyTherapyImgMob from "../../assets/Services/Mobile/Rectangle14.png";

// import MedicationManagementImg from "../../assets/Services/Desktop/Rectangle104.png";
// import MedicationManagementImgMob from "../../assets/Services/Mobile/Rectangle15.png";

// import HolisticTherapiesImg from "../../assets/Services/Desktop/Rectangle105.png";
// import HolisticTherapiesImgMob from "../../assets/Services/Mobile/Rectangle16.png";

// import AftercarePlanningImg from "../../assets/Services/Desktop/Rectangle106.png";
// import AftercarePlanningImgMob from "../../assets/Services/Mobile/Rectangle17.png";

// import EducationWorkshopsImg from "../../assets/Services/Desktop/Rectangle107.png";
// import EducationWorkshopsImgMob from "../../assets/Services/Mobile/Rectangle18.png";

// import PeerSupportGroupsImg from "../../assets/Services/Desktop/Rectangle108.png";
// import PeerSupportGroupsImgMob from "../../assets/Services/Mobile/Rectangle19.png";

// const servicesList = [
//   {
//     title: "Detoxification",
//     description:
//       "Our medically supervised detox program ensures a safe and comfortable withdrawal process, helping individuals clear substances from their body under expert care.",
//     imageDesktop: DetoxImg,
//     imageMobile: DetoxImgMob,
//   },
//   {
//     title: "Individual Therapy",
//     description:
//       "Personalized one-on-one counseling sessions address the unique challenges of each client, fostering self-awareness, emotional healing, and long-term change.",
//     imageDesktop: IndividualTherapyImg,
//     imageMobile: IndividualTherapyImgMob,
//   },
//   {
//     title: "Group Therapy",
//     description:
//       "Supportive group sessions provide a space to share experiences, gain perspective, and build connections with others on similar recovery journeys.",
//     imageDesktop: GroupTherapyImg,
//     imageMobile: GroupTherapyImgMob,
//   },
//   {
//     title: "Family Therapy",
//     description:
//       "We involve loved ones in the healing process, helping families understand addiction, improve communication, and rebuild trust together.",
//     imageDesktop: FamilyTherapyImg,
//     imageMobile: FamilyTherapyImgMob,
//   },
//   {
//     title: "Medication Management",
//     description:
//       "Our medical professionals prescribe and monitor necessary medications to support recovery, manage symptoms, and prevent relapse.",
//     imageDesktop: MedicationManagementImg,
//     imageMobile: MedicationManagementImgMob,
//   },
//   {
//     title: "Holistic Therapies",
//     description:
//       "Through yoga, meditation, art, and music therapy, we nurture mental, emotional, and physical well-being, complementing traditional treatments.",
//     imageDesktop: HolisticTherapiesImg,
//     imageMobile: HolisticTherapiesImgMob,
//   },
//   {
//     title: "Aftercare Planning",
//     description:
//       "We design personalized aftercare plans to ensure continued support and strategies for maintaining sobriety after leaving rehab.",
//     imageDesktop: AftercarePlanningImg,
//     imageMobile: AftercarePlanningImgMob,
//   },
//   {
//     title: "Education & Workshops",
//     description:
//       "Interactive sessions provide knowledge on addiction, relapse prevention, and essential life skills to empower clients for the future..",
//     imageDesktop: EducationWorkshopsImg,
//     imageMobile: EducationWorkshopsImgMob,
//   },
//   {
//     title: "Peer Support Groups",
//     description:
//       "We connect clients with others who have faced similar struggles, creating a community of understanding, encouragement, and mutual growth.",
//     imageDesktop: PeerSupportGroupsImg,
//     imageMobile: PeerSupportGroupsImgMob,
//   },
// ];

// /**
//  * Animated service card (for desktop only)
//  */
// const AnimatedServiceCard = ({ service, index, total, scrollYProgress }) => {
//   const slice = 1 / total;

//   const entryStart = index * slice;
//   const entryMid = entryStart + slice * 0.25;
//   const holdEnd = entryStart + slice * 0.65;
//   const exitEnd = entryStart + slice;

//   const opacityFirst = useTransform(scrollYProgress, [0, holdEnd, exitEnd], [1, 1, 0]);
//   const scaleFirst = useTransform(scrollYProgress, [0, holdEnd, exitEnd], [1, 1, 0.85]);
//   const yFirst = useTransform(scrollYProgress, [0, holdEnd, exitEnd], ["0%", "0%", "-14%"]);

//   const opacityOther = useTransform(
//     scrollYProgress,
//     [entryStart, entryMid, holdEnd, exitEnd],
//     [0, 1, 1, 0]
//   );
//   const scaleOther = useTransform(scrollYProgress, [entryStart, holdEnd, exitEnd], [1, 1, 0.85]);
//   const yOther = useTransform(scrollYProgress, [entryStart, holdEnd, exitEnd], ["0%", "0%", "-14%"]);

//   const opacity = index === 0 ? opacityFirst : opacityOther;
//   const scale = index === 0 ? scaleFirst : scaleOther;
//   const y = index === 0 ? yFirst : yOther;

//   return (
//     <motion.div
//       className="absolute top-0 left-0 w-full"
//       style={{
//         opacity,
//         scale,
//         y,
//         transformOrigin: "center top",
//         zIndex: index + 1,
//       }}
//     >
//       <ServiceCard {...service} />
//     </motion.div>
//   );
// };

// /**
//  * Main Component
//  */
// const ServicecardStack = () => {
//   const containerRef = useRef(null);
//   const [isMobile, setIsMobile] = useState(false);

//   // detect screen size
//   useEffect(() => {
//     const checkScreen = () => setIsMobile(window.innerWidth < 768);
//     checkScreen();
//     window.addEventListener("resize", checkScreen);
//     return () => window.removeEventListener("resize", checkScreen);
//   }, []);

//   const { scrollYProgress } = useScroll({
//     target: containerRef,
//     offset: ["start start", "end end"],
//   });

//   // MOBILE VIEW → simple list
//   if (isMobile) {
//     return (
//       <div ref={containerRef} className=" max-w-[1280px] mx-auto">
//         {servicesList.map((service, index) => (
//           <div key={index} className="mb-6">
//             <ServiceCard {...service} />
//           </div>
//         ))}
//       </div>
//     );
//   }

//   // DESKTOP VIEW → stacked animation
//   return (
//     <div
//       ref={containerRef}
//       style={{ height: `${servicesList.length * 100}vh` }}
//       className="relative"
//     >
//       <div className="sticky top-0 h-screen flex pt-[300px] justify-center overflow-hidden">
//         <div className="relative w-full max-w-[1280px] md:px-[75px] px-[24px]">
//           {servicesList.map((service, index) => (
//             <AnimatedServiceCard
//               key={index}
//               service={service}
//               index={index}
//               total={servicesList.length}
//               scrollYProgress={scrollYProgress}
//             />
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ServicecardStack;


import React from "react";
import { motion } from "framer-motion";
import ServiceCard from "./ServiceCard";

// // Images
import DetoxImg from "../../assets/Services/Desktop/Rectangle10.png";
import DetoxImgMob from "../../assets/Services/Mobile/Rectangle11.png";

import IndividualTherapyImg from "../../assets/Services/Desktop/Rectangle101.png";
import IndividualTherapyImgMob from "../../assets/Services/Mobile/Rectangle12.png";

import GroupTherapyImg from "../../assets/Services/Desktop/Rectangle102.png";
import GroupTherapyImgMob from "../../assets/Services/Mobile/Rectangle13.png";

import FamilyTherapyImg from "../../assets/Services/Desktop/Rectangle103.png";
import FamilyTherapyImgMob from "../../assets/Services/Mobile/Rectangle14.png";

import MedicationManagementImg from "../../assets/Services/Desktop/Rectangle104.png";
import MedicationManagementImgMob from "../../assets/Services/Mobile/Rectangle15.png";

import HolisticTherapiesImg from "../../assets/Services/Desktop/Rectangle105.png";
import HolisticTherapiesImgMob from "../../assets/Services/Mobile/Rectangle16.png";

import AftercarePlanningImg from "../../assets/Services/Desktop/Rectangle106.png";
import AftercarePlanningImgMob from "../../assets/Services/Mobile/Rectangle17.png";

import EducationWorkshopsImg from "../../assets/Services/Desktop/Rectangle107.png";
import EducationWorkshopsImgMob from "../../assets/Services/Mobile/Rectangle18.png";

import PeerSupportGroupsImg from "../../assets/Services/Desktop/Rectangle108.png";
import PeerSupportGroupsImgMob from "../../assets/Services/Mobile/Rectangle19.png";

const servicesList = [
  {
    title: "Detoxification",
    description:
      "Our medically supervised detox program ensures a safe and comfortable withdrawal process, helping individuals clear substances from their body under expert care.",
    imageDesktop: DetoxImg,
    imageMobile: DetoxImgMob,
  },
  {
    title: "Individual Therapy",
    description:
      "Personalized one-on-one counseling sessions address the unique challenges of each client, fostering self-awareness, emotional healing, and long-term change.",
    imageDesktop: IndividualTherapyImg,
    imageMobile: IndividualTherapyImgMob,
  },
  {
    title: "Group Therapy",
    description:
      "Supportive group sessions provide a space to share experiences, gain perspective, and build connections with others on similar recovery journeys.",
    imageDesktop: GroupTherapyImg,
    imageMobile: GroupTherapyImgMob,
  },
  {
    title: "Family Therapy",
    description:
      "We involve loved ones in the healing process, helping families understand addiction, improve communication, and rebuild trust together.",
    imageDesktop: FamilyTherapyImg,
    imageMobile: FamilyTherapyImgMob,
  },
  {
    title: "Medication Management",
    description:
      "Our medical professionals prescribe and monitor necessary medications to support recovery, manage symptoms, and prevent relapse.",
    imageDesktop: MedicationManagementImg,
    imageMobile: MedicationManagementImgMob,
  },
  {
    title: "Holistic Therapies",
    description:
      "Through yoga, meditation, art, and music therapy, we nurture mental, emotional, and physical well-being, complementing traditional treatments.",
    imageDesktop: HolisticTherapiesImg,
    imageMobile: HolisticTherapiesImgMob,
  },
  {
    title: "Aftercare Planning",
    description:
      "We design personalized aftercare plans to ensure continued support and strategies for maintaining sobriety after leaving rehab.",
    imageDesktop: AftercarePlanningImg,
    imageMobile: AftercarePlanningImgMob,
  },
  {
    title: "Education & Workshops",
    description:
      "Interactive sessions provide knowledge on addiction, relapse prevention, and essential life skills to empower clients for the future..",
    imageDesktop: EducationWorkshopsImg,
    imageMobile: EducationWorkshopsImgMob,
  },
  {
    title: "Peer Support Groups",
    description:
      "We connect clients with others who have faced similar struggles, creating a community of understanding, encouragement, and mutual growth.",
    imageDesktop: PeerSupportGroupsImg,
    imageMobile: PeerSupportGroupsImgMob,
  },
];

const ServiceCardStack = () => {
  return (
    <div className="max-w-[1280px] mx-auto ]">
      {servicesList.map((service, index) => (
        <motion.div
          key={index}
          className="mb-12"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6, delay: index * 0.1 }}
        >
          <ServiceCard {...service} />
        </motion.div>
      ))}
    </div>
  );
};

export default ServiceCardStack;
